// Function to handle technology clicks and update navbar state
export const handleTechnologyClick = (technology, setNavbarTop, setNavbarTopTwo, setSelectedTechnology) => {
  // Store the selected technology in localStorage
  localStorage.setItem('selectedTechnology', technology);

  // Update navbar states
  setNavbarTop(true);
  setNavbarTopTwo(true);

  // Update the local state in Home.js to show the technology details view
  if (setSelectedTechnology) {
    setSelectedTechnology(technology);
  }

  // Technology descriptions and specific logic
  switch (technology) {
    case 'web-development':
      // Web Development: Creating responsive, modern websites using latest technologies
      // Features: React, Angular, Vue.js, HTML5, CSS3, JavaScript
      // Services: Custom website development, E-commerce solutions, CMS development
      break;
    case 'php-development':
      // PHP Development: Server-side scripting for dynamic web applications
      // Features: Laravel, Symfony, CodeIgniter, WordPress
      // Services: Backend development, API integration, Database management
      break;
    case 'javascript-development':
      // JavaScript Development: Frontend and backend development using JavaScript
      // Features: Node.js, Express.js, React.js, Vue.js
      // Services: Single Page Applications, Progressive Web Apps, Real-time applications
      break;
    case 'fullstack-development':
      // Full Stack Development: End-to-end web application development
      // Features: MERN Stack, MEAN Stack, LAMP Stack
      // Services: Complete web solutions, Database design, API development
      break;
    case 'ai-ml-development':
      // AI/ML Development: Artificial Intelligence and Machine Learning solutions
      // Features: TensorFlow, PyTorch, Natural Language Processing
      // Services: Chatbots, Predictive analytics, Computer vision applications
      break;
    default:
      break;
  }
};

// Function to initialize navbar state from localStorage
export const initializeNavbarState = (setNavbarTop, setNavbarTopTwo, setSelectedTechnology) => {
  const selectedTechnology = localStorage.getItem('selectedTechnology');
  if (selectedTechnology) {
    setNavbarTop(true);
    setNavbarTopTwo(true);
    if (setSelectedTechnology) {
      setSelectedTechnology(selectedTechnology);
    }
  }
};

// Function to reset navbar state
export const resetNavbarState = (setNavbarTop, setNavbarTopTwo, setSelectedTechnology) => {
  localStorage.removeItem('selectedTechnology');
  setNavbarTop(false);
  setNavbarTopTwo(false);
  if (setSelectedTechnology) {
    setSelectedTechnology(null);
  }
}; 